import * as React from "react";

function SvgFlag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 23"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M23.9 4.85c-12.45 18.35-8.19-.36-18.71 8.59l2.39 9.58H4.89L0 3.5l2.47-.9c11.8-8.75 5.63 7.87 20.85 1.7.48-.2.87.12.58.55z" />
    </svg>
  );
}

const MemoSvgFlag = React.memo(SvgFlag);
export default MemoSvgFlag;
